import { render, staticRenderFns } from "./Calendario.vue?vue&type=template&id=11595db0&scoped=true&"
import script from "./Calendario.vue?vue&type=script&lang=js&"
export * from "./Calendario.vue?vue&type=script&lang=js&"
import style0 from "./Calendario.vue?vue&type=style&index=0&id=11595db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11595db0",
  null
  
)

export default component.exports